var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.293,
    height: 11.189,
    viewBox: "0 0 12.293 11.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-filter",
    transform: "translate(-3.4 -4.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13608",
    "data-name": "Path 13608",
    d: "M11.059,10.042H8.034L4,5H15.093Zm0,4.538L8.034,15.589V11.051h3.025Z",
    fill: "#533FFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13609",
    "data-name": "Path 13609",
    d: "M15.093,5.6H4A.6.6,0,0,1,4,4.4H15.093a.6.6,0,1,1,0,1.2Z",
    fill: "#533FFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingPurple);
export default __webpack_public_path__ + "static/media/sorting-purple.2916b516c997d1e4bb33b090e780a077.svg";
export { ForwardRef as ReactComponent };